import * as Types from '../types'

export const setOrderContext = ({ family, category, selectedCategory, selectedFamily }) => ({
    type: Types.ORDER_CONTEXT_UPDATE,
    family,
    category,
    selectedCategory,
    selectedFamily
})
